import React from 'react'
import PropTypes from 'prop-types'

import Pressable from 'src/ui/Pressable/Pressable'

import ListSkeleton from './ListSkeleton'
import ListItem from './subcomponents/ListItem/ListItem'

const EMPTY = []

const List = ({
  title,
  size = 'md',
  items = EMPTY,
  getItemUrl,
  itemIconShape,
  ItemState,
  ItemComponent = ListItem,
  DropPlaceholderComponent,
  draggable,
  removable,
  onReorder,
  onRemove,
  renderFooter,
}) => {
  return (
    <ListSkeleton
      titleSection={title}
      items={items}
      ItemComponent={(item) => (
        <Pressable
          linkUrl={getItemUrl?.(item) || item.linkUrl}
          disabled={draggable || removable}
        >
          <ItemComponent
            size={size}
            iconShape={itemIconShape}
            state={ItemState?.(item)}
            renderFooter={renderFooter?.(item.progress)}
            {...item}
          />
        </Pressable>
      )}
      DropPlaceholderComponent={DropPlaceholderComponent}
      draggable={draggable}
      removable={removable}
      onReorder={onReorder}
      onRemove={onRemove}
    />
  )
}

List.propTypes = {
  title: PropTypes.string,
  size: PropTypes.oneOf(['sm', 'md']),
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      iconUrl: PropTypes.string,
      name: PropTypes.string.isRequired,
    })
  ).isRequired,
  getItemUrl: PropTypes.func,
  itemIconShape: PropTypes.oneOf(['rounded']),
  ItemState: PropTypes.func,
  ItemComponent: PropTypes.func,
  DropPlaceholderComponent: PropTypes.func,
  draggable: PropTypes.bool,
  removable: PropTypes.bool,
  onReorder: PropTypes.func,
  onRemove: PropTypes.func,
  renderFooter: PropTypes.any,
}

export default List
